export default __webpack_public_path__ + "static/media/Mind Relaxation Meditation - 30s sample.c290a207.mp3";